/** Hook to load municipality names for the landing-page search. */

import { useEffect, useState } from "react";

import { apiClient } from "../api/client";
import { ApiError, type GemeindeOption } from "../types";

interface UseGemeindenResult {
  municipalities: GemeindeOption[];
  loading: boolean;
  error: string | null;
}

export function useGemeinden(): UseGemeindenResult {
  const [municipalities, setMunicipalities] = useState<GemeindeOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    apiClient
      .getGemeindeNames()
      .then((data) => {
        if (!cancelled) {
          setMunicipalities(data);
          setError(null);
        }
      })
      .catch((err: ApiError | Error) => {
        if (!cancelled) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { municipalities, loading, error };
}
